import { render, staticRenderFns } from "./welcome_platinum.vue?vue&type=template&id=1383a6c4&scoped=true"
import script from "./welcome_platinum.vue?vue&type=script&lang=js"
export * from "./welcome_platinum.vue?vue&type=script&lang=js"
import style0 from "./welcome_platinum.vue?vue&type=style&index=0&id=1383a6c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1383a6c4",
  null
  
)

/* custom blocks */
import block0 from "./welcome_platinum.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports